import React from 'react';
import classNames from 'classnames';

import { CoreLink } from '@uncinc/react-drupal-core';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import { WysiwygField } from '../../../../components';

import './style.scss';

const TaxonomyTermPillarTeaser = ({ entity, className }) => {
  const classes = classNames(className, 'Theme', 'TaxonomyTerm', 'TaxonomyTermPillarTeaser');

  const image = entity.getIn(['field_thumbnail', 0, 'styles', 'large'], '');
  const title = entity.getIn(['name', 0, 'value'], '');
  const body = entity.getIn(['description', 0, 'processed'], '');

  return (
    <article typeof="schema:WebPage" className={classes}>
      <CoreLink to={entity.getIn(['paths', 'nl'])} className="overlapping-link" />
      <div className="TaxonomyTermPillarTeaser__content">
        <div className="TaxonomyTermPillarTeaser__contentWrapper">
          <h2 className="TaxonomyTermPillarTeaser__heading">{title}</h2>
          <WysiwygField
            property="schema:text"
            className="TaxonomyTermPillarTeaser__body body-intro"
            html={body}
          />
        </div>
        <div className="TaxonomyTermPillarTeaser__imageWrapper">
          <Image
            alt="Image 1"
            lazyload={false}
            src={image}
          />
        </div>
      </div>
    </article>
  );
};

export default TaxonomyTermPillarTeaser;
